import { useStore } from 'vuex';
import Uid from "@/utils/Uid";
import Fitting from '@/models/Fitting';

export default function useSetLensPairId()
{
    const store = useStore();

    class SetLensPairId
    {
        async handle()
        {
            const lensPairId = Uid.dependencyCode();
            /** @type {?Fitting} */
            const rightFitting = store.getters['lensOrder/getFitting']('right');
            /** @type {?Fitting} */
            const leftFitting  = store.getters['lensOrder/getFitting']('left');

            if(rightFitting && leftFitting)
            {
                // We add "A" and "B" to lens pair id to distinguish side (necessary when quantity is more than 1)
                rightFitting.getPrototype().setValue('LENS_PAIR_ID', lensPairId + 'A');
                leftFitting.getPrototype().setValue('LENS_PAIR_ID', lensPairId + 'B');
                console.log(`Lens pair ID ${lensPairId} has been set on both sides`);
            }
            else if(rightFitting)
            {
                rightFitting.getPrototype().setValue('LENS_PAIR_ID', null);
                console.log('Lens pair ID has been reset on right side');
            }
            else if(leftFitting)
            {
                leftFitting.getPrototype().setValue('LENS_PAIR_ID', null);
                console.log('Lens pair ID has been reset on left side');
            }

            return true;
        }
    }

    return SetLensPairId;
}
